import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {errorMsg, getFullName} from "../../../../Apis/functions";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import {IconAvatarTable} from "../../../../components/buttons/IconButtons";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {DeleteZoneUser, ZoneDetailAuthorizedEmployee} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import {useParams} from "react-router-dom";
import TableFunction from "../../../../components/table/TableFunction";
import CustomTooltip from "../../../../components/CustomTooltip";

/**
 * @author Karen Yunuen Pozos Arias
 * @email kpozos@ibl.mx
 * @title Full Stack Developer
 * @component AuthorizedEmployeesTableApp
 * @description Renders the history table for a specific visitor item.
 *
 * @param {Object} item - Visitor object containing the visitor's unique identifier and related information.
 *
 */

export const  AuthorizedEmployeesTableApp = ({}) => {
    const {id} = useParams();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const dispatch = useDispatch();
    const [modified, setModified] = useState(false);
    const [tableId, setTableId] = useState("tbl_ae_authorized_employees"); // Set the table ID for identification
    const [results, setResults] = useState(null); // Store the search results
    const [show, setShow] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    /**
     * Generates the table header columns.
     * @returns {React.ReactNode[]} Array of header cells.
     */
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes="first_head">{t('employee')}</CustomTh>
        ];
    };
    /**
     * Generates the table body rows based on fetched data.
     * @returns {{ body: React.ReactNode[], data: Object[] }} Rendered table rows and raw data.
     */
    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item, index) => {
            let fullName =getFullName(item.name, item.firstLastName, item.secondLastName);

            return (
                <>
                    <CustomTd tableId={tableId} classes={"first-column "}>
                        <div className={"d-flex align-items-center"}>
                            <div><IconAvatarTable className={"mr-8px mb-1"}/></div>
                            <CustomTooltip
                                text={fullName}
                                classes={`fs-14px font-color-general-950 text-ellipsis`}
                                showIfTruncated={true}
                            />
                        </div>
                    </CustomTd>
                </>
            );
        });

        return {
            body: body, // Return the generated table rows
            data: results?.content?.map(e => ({...e, id: e.userId})) // Return the data associated with the rows
        };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            zoneId: id
        })
        dispatch(ZoneDetailAuthorizedEmployee(body)).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults({
                        ...data,
                        content: (data?.content || []).map((e) => ({ ...e, id: e.userId })),
                    });
                }
            },
        );
    }

    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { thead,tbody, t, handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage} = TableFunction({
        getTbody: getTbody,
        getThead: getThead,
        data: results,
        labelRowsPerPage: 'empolyee_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        selectedList,
        setSelectedList,

        getData,//New
        modified,//New
        setModified,//New
    });

    const handleManageEmployees = () => {
        setShow(true);
    };

    // handel delete zone employee
    const handleDeleteEmployee = () => {
        const data = {
            userIds: selectedList,
            zoneId: id,
        };
        dispatch(DeleteZoneUser(data)).then(
            ({payload: {data: { success, code }}}) => {
                if (success === true) {
                    toast.success(t('has_been_deleted_successfully'));
                    setShowDeleteModal(false);
                    setModified(true);
                    setIsAllChecked(false);
                    setSelectedList([]);
                }else errorMsg(code)
            },
        );

    };

    return {
        t,
        id,
        DEV,
        permission,
        tableId,
        thead,
        tbody,
        pagination,
        show,
        setShow,
        modified,
        setModified,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        showDeleteModal,
        setShowDeleteModal,
        handleDeleteAll,
        handleCheckboxChange,
        handleManageEmployees,
        handleDeleteEmployee
    };
};
